import {
  chakra,
  Tooltip as ChakraTooltip,
  PlacementWithLogical,
  useMediaQuery,
} from "@chakra-ui/react";
import { ReactNode, useState } from "react";

type TooltipProps = {
  label: ReactNode;
  content: ReactNode;
  bgColor: string | undefined;
  contentBgColor?: string | undefined;
  textColor: string | undefined;
  borderRadius?: string | undefined;
  placement?: PlacementWithLogical;
  closeDelay?: number;
};

export const BadgeTooltip = ({
  label,
  content,
  bgColor,
  textColor,
  borderRadius,
  placement,
  contentBgColor,
}: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isSmallerThan700] = useMediaQuery("(max-width: 700px)");

  return (
    <ChakraTooltip
      hasArrow
      label={content}
      isOpen={isVisible}
      closeDelay={isSmallerThan700 ? 2000 : 500}
      onClose={() => setIsVisible(false)}
      pointerEvents="all"
      color="textSecondary"
      fontSize="12px"
      bg={contentBgColor ? contentBgColor : "backgroundCard"}
      p="0"
      borderRadius="8px"
      placement={placement ? placement : "top"}
    >
      <chakra.span
        bg={`${bgColor}`}
        textColor={textColor}
        borderRadius={borderRadius ? borderRadius : 4}
        fontSize={10}
        paddingX={2}
        paddingY={2}
        fontWeight="bold"
        lineHeight={1}
        onMouseEnter={() => setIsVisible(true)}
        onClick={() => setIsVisible(true)}
      >
        {label}
      </chakra.span>
    </ChakraTooltip>
  );
};

export default BadgeTooltip;
